__turbopack_context__.v({
  "errorPageBody": "ErrorPage-module-scss-module__kmmyna__errorPageBody",
  "errorPageContent": "ErrorPage-module-scss-module__kmmyna__errorPageContent",
  "errorPageDescription": "ErrorPage-module-scss-module__kmmyna__errorPageDescription",
  "errorPageTitle": "ErrorPage-module-scss-module__kmmyna__errorPageTitle",
});
